import React, { useMemo } from 'react';
import dayjs from 'dayjs';

import { PDFImageProps } from '../../../../utils/models';

import Zippy from '../../../themed/zippy';
import CertificateForm from '../../../forms/generic/certificate-form';

import useProjectDetails from '../../../../hooks/useProjectDetails';

interface ICertificate {
    training: PDFImageProps[];
    calibration: PDFImageProps[];
};

interface Props {
    calibrationRequired: boolean;
    certificates?: ICertificate;
    onChangeCertificate: (certificate: ICertificate) => void;
}

const CustomCertificateForm: React.FC<Props> = ({ calibrationRequired, certificates, onChangeCertificate }) => {
    const { projectDetails } = useProjectDetails();

    const isValid = useMemo(() => {
        if (certificates) {
            const isTrainingProvided = certificates.training.length > 0;
            if (isTrainingProvided) return calibrationRequired ? certificates.calibration.length > 0 : true;
        }

        return false;
    }, [certificates, calibrationRequired]);

    const isRequired = useMemo(() => {
        return projectDetails ? dayjs(projectDetails.createdAt).isSameOrAfter(dayjs('2026-05-18')) : false;
    }, [projectDetails]);

    if (!isRequired) {
        return null;
    }

    return (
        <Zippy headerTitle="Training Certificates" isValid={isValid}>
            <CertificateForm calibrationRequired={calibrationRequired} initialData={certificates} onSave={onChangeCertificate} />
        </Zippy>
    );
};

export type { ICertificate };
export default CustomCertificateForm;